var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsFrame3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "#00A573",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_367_43216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12H15.5V14.625H12V12ZM12 15.5H15.5V18.125H12V15.5ZM12 22.5H15.5V25.125H12V22.5ZM12 19H15.5V21.625H12V19ZM16.375 12H26V14.625H16.375V12ZM16.375 15.5H26V18.125H16.375V15.5ZM16.375 22.5H26V25.125H16.375V22.5ZM16.375 19H26V21.625H16.375V19Z",
    fill: "#00A573"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_43216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsFrame3);
export default __webpack_public_path__ + "static/media/stats_frame_3.fdfccab159a74f1eb81b4d37aec585c0.svg";
export { ForwardRef as ReactComponent };